import React from "react";
import { Helmet } from "react-helmet";
const HelmetReact = ({ title }) => {
  return (
    <Helmet>
      <title>
        {title} || Next Global - Reliable Supply, Powerful Solutions
      </title>
      <meta
        name="description"
        content="Next Global - Reliable Supply, Powerful Solutions"
      />
    </Helmet>
  );
};

export default HelmetReact;
